import { useEffect } from "react";
import { useLocation } from "react-router";
import analytics from "app/segment";

type Props = {
  children: React.ReactNode;
};

export const Router = ({ children }: Props) => {
  const location = useLocation();
  useEffect(() => {
    analytics.page();
  }, [location]);

  return <>{children}</>;
};
